import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { MobileNavbarItem, PageWithBottomNavbar } from "@seneca/senekit";
import { TUTORING_LEAD_SOURCES } from "@seneca/tutoring-service-consts";

import { linkToMonitoringPage } from "features/parents/links";
import { linkToChildAssignmentsPage } from "features/parents/routes/parent/routes/child/routes/assignments/links";
import {
  linkToWeeklyReportsForPreviousWeek,
  linkToWeeklyReportsRoute
} from "features/parents/routes/parent/routes/child/routes/weekly-reports/links";
import { linkToMorePage } from "features/parents/routes/parent/routes/mobile/more/links";
import { linkToMonitoringOverviewPage } from "features/parents/routes/parent/routes/monitoring/routes/overview/links";
import { linkToTutoringPage } from "features/parents/routes/parent/routes/tutoring-page/links";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

import locationIncludesMoreRoute from "../utils/locationIncludesMoreRoute";

export default function ParentMobileNavbar({
  children,
  showTutoring,
  selectedChildId
}: {
  children: ReactNode;
  showTutoring: boolean;
  selectedChildId?: string;
}) {
  const location = useLocation();

  const isiOSApp = isNativeAppiOS();

  const linkBookOneToOneTutoring = linkToTutoringPage(
    TUTORING_LEAD_SOURCES.NAVBAR
  );

  return (
    <PageWithBottomNavbar isiOSApp={isiOSApp}>
      {{
        page: children,
        navbarItems: [
          <MobileNavbarItem
            label="Home"
            to={linkToMonitoringPage()}
            isActive={location.pathname.includes(
              linkToMonitoringOverviewPage()
            )}
            iconName="house"
          />,

          <MobileNavbarItem
            label="Assignments"
            to={linkToChildAssignmentsPage(selectedChildId)}
            isActive={location.pathname.includes(
              linkToChildAssignmentsPage(selectedChildId)
            )}
            iconName="notePencil"
            disabled={!selectedChildId}
          />,

          <MobileNavbarItem
            label="Reports"
            to={linkToWeeklyReportsForPreviousWeek(selectedChildId || "")}
            isActive={location.pathname.includes(
              linkToWeeklyReportsRoute(selectedChildId)
            )}
            iconName="report"
            disabled={!selectedChildId}
          />,

          <>
            {showTutoring && (
              <MobileNavbarItem
                label="1:1 tutor"
                to={linkBookOneToOneTutoring}
                isActive={location.pathname.includes(linkToTutoringPage())}
                iconName="classes"
                disabled={!showTutoring}
              />
            )}
          </>,

          <MobileNavbarItem
            label="More"
            to={linkToMorePage()}
            isActive={locationIncludesMoreRoute(location)}
            iconName="more"
          />
        ]
      }}
    </PageWithBottomNavbar>
  );
}
